import { createAction } from 'typesafe-actions'
import { SessionActionTypes } from './types'

export const initSession = createAction(SessionActionTypes.INIT)<boolean>()
